export default __webpack_public_path__ + "5cdc2e11fea378aded9f2270ddbd4620.jpg";